<template>
  <div>
    <span class="form-title">{{ selectedBrand.name }} sizes</span>

    <div id="letter-sizes-block" class="input-form" :class="{disabled: !hasLetterSizes}">
      <div class="form-group no-margin">
        <span class="sub-title">Letter sizes</span>
        <div id="letter-sizes-container">
          <div class="size-box" v-for="(size, index) in selectedBrand.sizes.international" @click="appendSelection(size)" :key="`letter-size-${index}`">
            {{ size }}
          </div>
        </div>
      </div>
    </div>

    <div id="numeric-sizes-block" class="form-group" :class="{disabled: !hasNumberSizes}">
      <span class="sub-title">Numeric sizes</span>
      <div id="numeric-sizes-container">
        <div class="size-box" v-for="(size, index) in selectedBrand.sizes.numeric" @click="appendSelection(size)" :key="`numeric-size-${index}`">
          {{ size }}
        </div>
      </div>
    </div>

    <div class="footer-navigation">
      <div class="back-step-btn" @click="$emit('back')">&lt; Back</div>
    </div>
  </div>
</template>

<script>
import ConfigurationService from "../../../../services/ConfigurationService";

export default {
  name: "SelectSize",

  props: ['selectedBrand'],

  computed: {
    hasLetterSizes() {
      return ConfigurationService.getSizeType() === 'letter';
    },

    hasNumberSizes() {
      return ConfigurationService.getSizeType() === 'number';
    },
  },

  methods: {
    appendSelection(size) {
      this.$store.commit('userSelections/addBrand', {
        id: this.selectedBrand.id,
        name: this.selectedBrand.name,
        size,
      });

      this.$emit('back');
    },
  },
};
</script>
